import { parseJson, stringifyJson } from "./lodash.js";
const getStorageValue = (key, storage = window.localStorage) => {
  const storageValue = storage.getItem(key);
  return storageValue && parseJson(storageValue);
};
const setStorageValue = (key, value, storage = window.localStorage) => {
  const storageValue = stringifyJson(value);
  storageValue && storage.setItem(key, storageValue);
};
const removeStorageValue = (key, storage = window.localStorage) => storage.removeItem(key);
export {
  getStorageValue,
  removeStorageValue,
  setStorageValue
};
//# sourceMappingURL=storage.js.map
